export default __webpack_public_path__ + "static/media/flying-saucer.76a6c26b.svg";